import styled, { css } from "styled-components";

export const FooterSeoCont = styled.div`
  position: relative;

  & li,
  h3,
  h2 {
    padding: 8px 0;
  }

  & ul {
    list-style-type: disc;
  }

  & ol {
    list-style-type: decimal;
  }

  & li p {
    margin: 0;
  }

  & ol li > h3,
  & ul li > h3,
  & ol li > p,
  & ul li > p {
    display: inline;
  }

  & p,
  p * {
    margin: 8px 0 16px;
    font-size: 16px !important;
    line-height: 2em;
  }

  & p:last-child{
  margin: 8px 0 0;
  }

  ${({ theme: { isMobile } }) =>
    isMobile
      ? css`
          & h2 {
            font-size: 16px;
            line-height: 1.1em;
          }
        `
      : css`
          & h2 {
            font-size: 20px;
            line-height: 1.1em;
          }
        `}
`;

export const FooterSeoWrap = styled.div<{ viewAll?: boolean }>`
  ${({ theme: { isDesktop }, viewAll }) =>
    isDesktop &&
    `
          height: ${viewAll ? "auto" : "175px"};
          overflow: ${viewAll ? "unset" : "hidden"};
          box-shadow: ${viewAll ? "none" : "3px 10px 3px rgb(43 89 255 / 8%)"};
        `}
`;
export const Header = styled.h2`
  line-height: 1.1em;
  display: block;
  font-size: 32px !important;
`;

export const ViewAll = styled.span`
  position: absolute;
  bottom: 10px;
  ${({ theme }) => (theme.locale == "ar" ? "left:30px" : "right:30px")};
  font-size: 20px;
  cursor: pointer;
`;
